// @flow

import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
// material-ui
import { Table, TableBody, TableRow, TableHeader, TableHeaderColumn, TableRowColumn } from 'material-ui/Table';
import InfoStringListItem from './InfoStringListItem';
import FlatButton from 'material-ui/FlatButton';
import { styles } from '../../lib/styles';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { EmptyView } from '../empty-view';
import ArticleListItem from '../articles/ArticleListItem';

const InfoStringList = props => {
	const items = props.viewer.infoStrings.edges;
	const articles = props.viewer.articles;

	const length = items.length + articles.length;

	return (
		<section className="wrapper">
			<div className="paper-wrapper" style={{ width: '100%' }}>
				<section className="paper paper_main articles">
					<header className="paper-header" style={{ alignItems: 'center', justifyContent: 'space-between' }}>
						<h3 className="articles-header--title">Бегущая строка</h3>

						<FlatButton
							label="Добавить"
							style={{ ...styles.headerButton, marginLeft: 8 }}
							primary
							icon={<ContentAdd />}
							onClick={() => props.history.push(`/info-strings/new`)}
							labelStyle={{ paddingLeft: 6, paddingRight: 18 }}
						/>
					</header>
					{length === 0 ? (
						<EmptyView />
					) : (
						<section className="articles-list">
							<Table className="table">
								<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
									<TableRow style={{ border: 0 }}>
										<TableHeaderColumn className="table--cell table--cell-th">Заголовок</TableHeaderColumn>
										<TableHeaderColumn className="table--cell table--cell-th">Информация</TableHeaderColumn>
									</TableRow>
								</TableHeader>
								<TableBody showRowHover stripedRows>
									{items.map(edge => (
										<InfoStringListItem key={edge.node.__id} item={edge.node} router={props.router} viewer={props.viewer} />
									))}
									{articles.edges.map(edge => (
										<ArticleListItem
											targetSection="infoStrings"
											refetch={props.relay.refetch}
											key={edge.node.__id}
											article={edge.node}
											router={props.router}
											viewer={props.viewer}
										/>
									))}
								</TableBody>
							</Table>
						</section>
					)}
				</section>
			</div>
		</section>
	);
};

export default withRouter(
	createRefetchContainer(
		InfoStringList,
		graphql`
			fragment InfoStringList_viewer on Viewer @argumentDefinitions(blockSlug: { type: "String" }) {
				infoStrings: infoStrings {
					edges {
						node {
							...InfoStringListItem_item
						}
					}
				}
				configurableBlock(slug: $blockSlug) {
					id
					type
					slug
					config
					active
				}
				articles: articleForInfoStrings(first: 100) {
					edges {
						node {
							...ArticleListItem_article
						}
					}
				}
			}
		`,
		graphql`
			query InfoStringList_Refetch_Query($blockSlug: String!) {
				viewer {
					...InfoStringList_viewer @arguments(blockSlug: $blockSlug)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/info-strings/InfoStringList.js